import React, { useState } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import Skeleton from '@material-ui/lab/Skeleton';
import cx from 'classnames';
import { isNil } from 'lodash';

import { ReactComponent as CelebrationIcon } from 'pages/Teachers/ClassroomInsights/assets/celebration-icon.svg';
import { ReactComponent as ReviseIcon } from 'pages/Teachers/ClassroomInsights/assets/revise-icon.svg';
import { ReactComponent as InfoIcon } from 'pages/Teachers/ClassroomInsights/assets/tomorrow-focus-icon.svg';
import PreviewField from 'pages/Teachers/shared/PreviewField';
import { colors } from 'theme/palette';
import { formatRelativeTime } from 'utils/date';

import Typography from 'components/Typography';

import styles from './style.module.scss';

const TomorrowsFocus = ({
  celebrationsStudents,
  tomorrowsFocus,
  isLoading,
  isProcessing,
  lastUpdatedAt
}) => {
  const [loadAllStudents, setLoadAllStudents] = useState(false);

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div>
          {' '}
          <InfoIcon />
          <Typography variant="S-TEAXT-2" color={colors.grey2}>
            Tomorrow's Focus
          </Typography>
          {isProcessing && <CircularProgress size={20} />}
        </div>

        {lastUpdatedAt && (
          <div>Updated {formatRelativeTime({ date: lastUpdatedAt })}</div>
        )}
      </header>
      <Divider className={styles.divider} />
      <div className={styles.revisitSection}>
        <header className={styles.sectionHeader}>
          <ReviseIcon />
          <Typography variant="S-TEAXT-2">Revisit</Typography>
        </header>

        {isLoading && (
          <ul className={styles.content}>
            {[0, 1].map((item) => (
              <li key={item}>
                {Array.from({ length: 5 }).map((_, i) => (
                  <Skeleton key={i} animation="wave" />
                ))}
              </li>
            ))}
          </ul>
        )}

        {isNil(tomorrowsFocus) && !isLoading && (
          <div className={styles.noStudents}>
            No data available for tomorrow's focus.
          </div>
        )}

        <ul className={styles.content}>
          {!isNil(tomorrowsFocus) &&
            !isLoading &&
            tomorrowsFocus.map((item, idx) => (
              <li key={idx}>
                <PreviewField initialValue={item} />
              </li>
            ))}
        </ul>
      </div>

      <div
        className={cx(styles.celebrationsSection, {
          [styles.noStudentsSection]: celebrationsStudents?.length === 0
        })}
      >
        <header className={cx(styles.sectionHeader, styles.withStudents)}>
          <div>
            <CelebrationIcon />
            <Typography variant="S-TEAXT-2">Celebrations</Typography>
          </div>
          {celebrationsStudents?.length > 0 && !isLoading && (
            <div className={styles.studentCount}>
              {celebrationsStudents?.length}{' '}
              {celebrationsStudents?.length === 1 ? 'Student' : 'Students'}
            </div>
          )}
        </header>
        <div className={styles.content}>
          {(isLoading || isNil(celebrationsStudents)) && (
            <div className={styles.noStudents}>
              <ul>
                <li>
                  <Skeleton animation="wave" />
                </li>
              </ul>
              <div className={styles.students}>
                {Array.from({ length: 2 }).map((_, i) => (
                  <Skeleton
                    key={i}
                    animation="wave"
                    className={styles.student}
                  />
                ))}
              </div>
            </div>
          )}

          {!isNil(celebrationsStudents) &&
            celebrationsStudents?.length === 0 &&
            !isLoading && (
              <div className={styles.noStudents}>
                No students have mastered the concept yet.
              </div>
            )}

          {celebrationsStudents?.length > 0 && !isLoading && (
            <>
              <ul>
                <li>
                  {celebrationsStudents?.length}{' '}
                  {celebrationsStudents?.length === 1 ? 'student' : 'students'}{' '}
                  mastered the concept!
                </li>
              </ul>
              <div className={styles.students}>
                {celebrationsStudents?.length > 2 && !loadAllStudents && (
                  <>
                    {celebrationsStudents?.slice(0, 2).map((student, index) => (
                      <div key={index} className={styles.student}>
                        {student.student_name}
                      </div>
                    ))}
                    <div
                      className={styles.loadMore}
                      onClick={() => setLoadAllStudents(true)}
                    >
                      + {celebrationsStudents?.length - 2} more
                    </div>
                  </>
                )}
                {(loadAllStudents || celebrationsStudents?.length <= 2) && (
                  <>
                    {celebrationsStudents?.map((student, index) => (
                      <div key={index} className={styles.student}>
                        {student.student_name}
                      </div>
                    ))}
                    {celebrationsStudents?.length > 2 && (
                      <div
                        className={styles.loadMore}
                        onClick={() => setLoadAllStudents(false)}
                      >
                        show less
                      </div>
                    )}
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TomorrowsFocus;
